import React, { useEffect, useState } from "react";
import {
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Avatar,
  IconButton,
  Box,
  Flex,
  Text,
  Spinner,
  useToast,
  Button,
  Select,
} from "@chakra-ui/react";
import { FaTimes } from "react-icons/fa";
import EditBusStudent from "./Edit_bus_student";
import { useParams } from "react-router-dom";
import ListBusTrView from "./List_bus_tr_view";
import Admin_Modal_Pay_Fee from "../BusProfileStudentIndividual/Admin_Modal_Pay_Fee";
import { BASE_URL } from "../../../Globalapi/Globalapi";
const RouteStudentsTable = () => {
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [viewType, setViewType] = useState("students"); // "teachers" or "students"
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { id } = useParams(); // Extracting busRouteId from URL parameters
  const schoolId = sessionStorage.getItem("school_id"); // Assuming school ID is stored in sessionStorage
  const toast = useToast();
  const [payFee, setPayFee] = useState([]);

  useEffect(() => {
    fetchStudents();
  }, [schoolId, id]);

  const fetchStudents = async () => {
    if (!schoolId || !id) {
      setError("School ID or Bus Route ID is missing.");
      setLoading(false);
      return;
    }

    try {
      const response = await fetch(
        `${BASE_URL}/admin/bus/students/list_bus_students.php?school_id=${schoolId}&bus_route_id=${id}`
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log("list student bus", data);

      if (data.success) {
        setStudents(data.data); // Assuming data.data contains the student list
      } else {
        setError(data.message || "Failed to fetch students.");
      }
    } catch (err) {
      setError("An error occurred while fetching data.");
    } finally {
      setLoading(false);
    }
  };

  const RefreshData = () => {
    fetchStudents();
  };

  const handleDeleteStudent = async (studentId, allocationId) => {
    try {
      const response = await fetch(
        `${BASE_URL}/admin/bus/students/delete_student.php`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },

          body: JSON.stringify({
            user_id: sessionStorage.getItem("user_id"),
            school_id: schoolId,
            student_id: studentId,
            allocation_id: allocationId,
          }),
        }
      );
      console.log(" res dele", response);

      const data = await response.json();
      console.log("dele", data);

      if (data.success) {
        toast({
          title: "Success",
          description: "Student allocation deleted successfully.",
          status: "success",
          duration: 3000,
          isClosable: true,
        });

        setStudents((prevStudents) =>
          prevStudents.filter((student) => student.student_id !== studentId)
        );
      } else {
        toast({
          title: "Error",
          description: data.message || "Failed to delete allocation.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error("Error deleting student allocation:", error);
      toast({
        title: "Error",
        description: "An error occurred while deleting allocation.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  // Pagination logic
  const totalPages = Math.ceil(students.length / rowsPerPage);
  const currentData = students.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) setCurrentPage(page);
  };

  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  if (loading) {
    return <Spinner size="xl" />;
  }

  if (error) {
    return <Text color="red.500">{error}</Text>;
  }
  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };
  return (
    <Box>
      <Box className="sb" p={4}>
        <Flex justify="space-between">
          <Select
            value={rowsPerPage}
            onChange={handleRowsPerPageChange}
            width="120px"
          >
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={20}>20</option>
          </Select>

          <Select
            value={viewType}
            onChange={(e) => setViewType(e.target.value)}
            width="200px"
          >
            <option value="students">Students View</option>
            <option value="teachers">Teachers View</option>
          </Select>
        </Flex>
      </Box>

      {viewType === "teachers" ? (
        <ListBusTrView />
      ) : (
        <Box>
          <Box overflowX="auto" maxWidth="100%">
            <Table
              sx={{
                "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
              }}
              size="md"
            >
              <Thead>
                <Tr>
                  <Th>Student Name</Th>
                  <Th>Pickup Point</Th>
                  <Th>Drop Point</Th>
                  <Th>Start Date</Th>
                  <Th>End Date</Th>
                  <Th>Due Date</Th>
                  <Th>Bus Fee</Th>
                  <Th>Fine</Th>
                  <Th>Action</Th>
                </Tr>
              </Thead>
              <Tbody>
                {currentData.map((student) => (
                  <Tr key={student.student_id}>
                    <Td>
                      <Box display="flex" alignItems="center" gap={2}>
                        <Avatar
                          size="sm"
                          src={student.avatar}
                          name={student.name}
                        />
                        <Text>{student.name}</Text>
                      </Box>
                    </Td>
                    <Td>{student.pickup_location}</Td>
                    <Td>{student.drop_location}</Td>
                    <Td>{student.start_date}</Td>
                    <Td>{student.end_date}</Td>
                    <Td>{student.due_date}</Td>
                    <Td>{student.bus_fee}</Td>
                    <Td>{student.fine}</Td>
                    <Td>
                      <Box display="flex" gap={2}>
                        <EditBusStudent
                          RefreshData={RefreshData}
                          student={student.student_id}
                          allocation_id={student.allocation_id}
                        />
                        <Button
                          colorScheme="red"
                          size="sm"
                          leftIcon={<FaTimes />}
                          onClick={() =>
                            handleDeleteStudent(
                              student.student_id,
                              student.allocation_id
                            )
                          }
                        ></Button>
                        <Button
                          colorScheme="teal"
                          variant="solid"
                          width="full"
                          size="sm"
                          fontWeight="bold"
                          onClick={() => {
                            handleOpenModal();
                            setPayFee(student);
                          }}
                        >
                          Pay
                        </Button>
                      </Box>
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </Box>
          {isModalOpen && (
            <Admin_Modal_Pay_Fee
              isOpen={isModalOpen}
              onClose={handleCloseModal}
              // amount={transportInfo.transportFee}
              // last={transportInfo.paymentDueDate}
              // start={transportInfo.startDate}
              // feeId={transportInfo.recordId}
              studentId={payFee.student_id}
              userId={payFee.user_id}
            />
          )}
          <Box display="flex" justifyContent="end" className="sb2" p={3}>
            <Button
              onClick={() => handlePageChange(currentPage - 1)}
              isDisabled={currentPage === 1}
            >
              Prev
            </Button>
            <Box display="flex" gap={2}>
              {Array.from({ length: totalPages }, (_, i) => (
                <Button
                  key={i}
                  onClick={() => handlePageChange(i + 1)}
                  colorScheme={currentPage === i + 1 ? "teal" : "gray"}
                >
                  {i + 1}
                </Button>
              ))}
            </Box>
            <Button
              onClick={() => handlePageChange(currentPage + 1)}
              isDisabled={currentPage === totalPages}
            >
              Next
            </Button>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default RouteStudentsTable;
